import { render, staticRenderFns } from "./HomeSEO.vue?vue&type=template&id=4fa304e6&scoped=true&"
import script from "./HomeSEO.vue?vue&type=script&lang=js&"
export * from "./HomeSEO.vue?vue&type=script&lang=js&"
import style0 from "./HomeSEO.vue?vue&type=style&index=0&id=4fa304e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa304e6",
  null
  
)

export default component.exports